import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
export default function addSidebarNav() {
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    if (app.forum.attribute('blogAddSidebarNav')) {
      items.add('blog', m(LinkButton, {
        icon: "fas fa-comment",
        href: app.route('blog')
      }, app.translator.trans('fof-blog.forum.blog')), 15);
    }
    return items;
  });
}
flarum.reg.add('fof-blog', 'forum/utils/addSidebarNav', addSidebarNav);